export default __webpack_public_path__ + "static/media/Mexico.734e4a87.png";